import { mergeMinuteKlineData, normalizeMinuteQuotations } from './normalizeKlineData';

/**
 * 将 quotations 全量合并进 K 线列表。
 * @param {Array} list
 * @param {object|null|undefined} payload
 * @param {{ mergeMode?: 'minute'|'period' }} [options] minute：按 timeIndex；period：按 date / weekId / monthId（日周月 K）
 * @returns {Array}
 */
export function mergeKlineListFromHistory(list, payload, options = {}) {
  const bars = normalizeMinuteQuotations(payload?.quotations, options);
  if (!bars.length || !Array.isArray(list)) {
    return list;
  }
  const result = mergeMinuteKlineData(list, bars, options);
  return result;
}
